export const USER_SET = 'USER_SET';
export const USER_LOGGED = 'USER_LOGGED';

export const MQTT_USER_SET = 'MQTT_USER_SET';
export const MQTT_CONNECTED_SET = 'MQTT_CONNECTED_SET';

export const BUILDINGS_SET = 'BUILDINGS_SET';
export const BUILDING_SET_SELECTED = 'BUILDING_SET_SELECTED';

// export const ZONES_SET = 'ZONES_SET';

export const DEVS_SET = 'DEVS_SET';
export const DEV_UPDATE_PROP = 'DEV_UPDATE_PROP';

export const CTRL_FAIL_SNACKBAR = 'CTRL_FAIL_SNACKBAR';

export const SHOW_LEFT_MENU = 'SHOW_LEFT_MENU';


